module.exports = __webpack_public_path__ + "static/media/5.d310ece1.jpg";